// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_je-0";
export var fulfillmentPanelBody = "_je-1";